import React, { useMemo } from "react";
import TableFilterCopyContacts from "../../lists/components/copy/TableFilterCopyContacts";
import { useConfigStore } from "../../../../stores/ConfigStore";

const valueMap = {
  subscriber: "payant",
  trial: "essai",
  free: "gratuit",
  web_search: "recherche web",
  other: "autre",
  linkedin: "linkedin",
  referral: "recommandation",
  trade_show: "salon",
  linkedin_message: "message linkedin",
  linkedin_post: "post linkedin"
};

function replaceFieldNamesWithIds(dataFields, filter) {
  function transform(node) {
    // If the node is a filter with "items" array
    if (node && Array.isArray(node.items)) {
      return {
        ...node,
        items: node.items.map((item) => transform(item)),
      };
    }

    // If the node is a single condition with "field"
    if (node && node.field) {
      const match = [
        ...dataFields,
        { name: "", id: 1894, identifier_placeholder: "%22_in_a_reseller%" },
      ].find((f) => f.identifier_placeholder.includes(node.field));

      let newValue = node.value;
      // Replace value if it matches our map
      if (typeof node.value === "string" && valueMap[node.value]) {
        newValue = valueMap[node.value];
      }

      if (node.operator === "does_exist") {
        return {
          ...node,
          field: match ? match.id.toString() : node.field,
          operator: "equals",
          value: "oui",
        };
      }

      if (node.operator === "does_not_exist") {
        return {
          ...node,
          field: match ? match.id.toString() : node.field,
          operator: "equals",
          value: "non",
        };
      }

      return {
        ...node,
        field: match ? match.id.toString() : node.field,
        value: newValue,
      };
    }

    return node;
  }

  return transform(filter);
}

const ResellersUsersExport = ({
  id,
  selectedIds,
  filter,
  filterResultNumber,
  total,
  onFinish,
}) => {
  const datafields = useConfigStore((s) => s.datafields);

  return (
    <TableFilterCopyContacts
      id={id}
      selectedIds={selectedIds}
      filter={replaceFieldNamesWithIds(datafields, filter)}
      filterResultNumber={filterResultNumber}
      total={total}
      onFinish={onFinish}
      isMagileads
      isGlobal
    />
  );
};

export default ResellersUsersExport;
